'use client';

import { Box, Typography } from '@mui/material';

export function LobbyView() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
      }}
    >
      <Typography variant="h4" color="primary" sx={{ fontWeight: 500 }}>
        Martins Ads
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
        Bem-vindo ao Martins Ads
      </Typography>
    </Box>
  );
}
